import React from 'react';

export default function Empty(props) {
  return (<> {
    props.children
  } < />
  );
}